import * as __WEBPACK_EXTERNAL_MODULE_clsx__ from "clsx";
import * as __WEBPACK_EXTERNAL_MODULE_tailwind_merge_e05e3e95__ from "tailwind-merge";
function cn(...inputs) {
    return (0, __WEBPACK_EXTERNAL_MODULE_tailwind_merge_e05e3e95__.twMerge)((0, __WEBPACK_EXTERNAL_MODULE_clsx__.clsx)(inputs));
}
export { cn };
